<template>
	<!-- T&C -->
	<modal
		class="integration-modal"
		:size="'large'"
		:show-close="false"
		@close="isVisible = false"
		v-if="isVisible">
		<template slot="header">
			<h3><i class="material-icons">book</i>Terms & Conditions</h3>
		</template>
		<template slot="body">
			<div class="terms-conditions mb-4">
				<iframe
					:src="agreementUrl"
					class="w-100">
				</iframe>
			</div>
			<div class="row">
				<div class="col-md-6">
					<div class="id-card-upload">
						<p><b>Please upload your Identification Card (KTP)</b></p>
						<!-- <div
							class="id-card-preview has-shadow mb-3"
							v-if="idCardUrl !== ''">
							<img :src="idCardUrl">
						</div> -->
						<div
							class="id-card-preview has-shadow mb-3"
							v-if="idCard && idCard !== ''">
							<img :src="idCard">
						</div>
						<!-- Image Uploader -->
						<image-uploader
							key="idCard"
							:label="'Upload your ID Card'"
							:multiple="false"
							:public="false"
							:prefix="userId"
							@uploaded="setIdCard"
							@loaded="onImageLoaded">
						</image-uploader>
						<!-- <small></small> -->
					</div>
				</div>
				<div class="col-md-6 hidden">
					<div class="id-card-upload">
						<p><b>Take a selfie with your Identification Card (KTP)</b></p>
						<div
							class="id-card-preview has-shadow mb-3"
							v-if="idCardSelfieUrl !== ''">
							<img :src="idCardSelfieUrl">
						</div>
						<!-- Image Uploader -->
						<image-uploader
							key="idCard"
							:label="'Upload your Selfie'"
							:multiple="false"
							@uploaded="setIdCardSelfie">
						</image-uploader>
						<!-- <small></small> -->
					</div>
				</div>
			</div>
		</template>
		<template slot="footer">
			<!-- <button
				type="button"
				class="btn btn-default"
				@click="isVisible = false">
				Cancel
			</button> -->
			<button
				type="button"
				class="btn btn-primary"
				:class="{ 'is-loading': isAccepting }"
				:disabled="!isFormValid"
				@click="accept">
				I ACCEPT THE TERMS & CONDITIONS
			</button>
		</template>
	</modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import localforage from 'localforage';
import Modal from '@/components/Modal.vue';
import ImageUploader from '@/components/ImageUploader.vue';
import { AGREEMENTS_VERSION } from '../lib/statics';
import { duplicateVar } from '../lib/helper';
import userApi from '@/api/user';

export default {
	name: 'AgreementModal',
	components: {
		Modal,
		ImageUploader,
	},
	data() {
		return {
			terms: '',
			isVisible: false,
			isAccepting: false,
			idCardUrl: '',
			idCardSelfieUrl: '',
			agreementUrl: 'https://docs.google.com/document/d/e/2PACX-1vRFk-MQ1E0geP0TVy72z1v7EEK_EpV0ApJbi2EyG_Gi9UC9jmhuG4ES40NICNaj4A/pub?embedded=true',
			idCard: '',
		};
	},
	methods: {
		...mapActions({
			setUser: 'setUser',
		}),
		checkAgreement() {
			let isAccepted = false;
			if (this.isOwner) {
				const settings = duplicateVar(this.user.settings);
				if (settings.agreements) {
					const agreements = settings.agreements;
					const agreementName = 'logistic';
					const agreement = agreements.find(({ name }) => name === agreementName);
					if (agreement) {
						isAccepted = agreement.accepted && agreement.version === AGREEMENTS_VERSION.LOGISTIC;
					}
				}
				if (settings.id_card && settings.id_card !== '') {
					this.idCardUrl = settings.id_card;
				}
			} else {
				isAccepted = true;
			}
			this.isVisible = !isAccepted;
		},
		accept() {
			this.isAccepting = true;
			const settings = duplicateVar(this.user.settings);
			const agreements = settings.agreements || [];

			const agreement = {
				name: 'logistic',
				accepted: true,
				version: AGREEMENTS_VERSION.LOGISTIC,
			};

			agreements.push(agreement);

			// settings.agreements = agreements;
			// settings.id_card = this.idCardUrl;

			const updatedSettings = {
				agreements,
				id_card: this.idCardUrl,
			};

			const callback = (response) => {
				// const user = duplicateVar(this.user);
				// user.settings = settings;
				const user = response.data;
				this.setUser(user);
				this.isAccepting = false;
				this.isVisible = false;
				this.$emit('accept');
			};
			const errorCallback = () => {
				this.isAccepting = false;
			};
			userApi.updateSettings(updatedSettings, callback, errorCallback);

			// const localSettings = duplicateVar(settings);
			// localforage.setItem('settings', localSettings);
		},
		setIdCard(url) {
			this.idCardUrl = url;
		},
		setIdCardSelfie(url) {
			this.idCardSelfieUrl = url;
		},
		onImageLoaded(imageData) {
			this.idCard = imageData;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isOwner: 'isOwner',
		}),
		isFormValid() {
			return this.idCardUrl !== '';
		},
		userId() {
			return this?.user?._id ?? '';
		},
	},
	created() {
		if (this.user) {
			this.checkAgreement();
		}
	},
	watch: {
		user() {
			if (this.user) {
				this.checkAgreement();
			}
		},
	},
};
</script>
